import { GetterTree } from 'vuex';
import AuthState from './state';
import RootState from '@/store/root/state';
import LoginModel from '@/models/LoginModel';



/**
 * Name of authorizedUser getter.
 */
export const AUTHORIZED_USER: string = 'authorizedUser';

/**
 * Returns actual authorized User, or null.
 * 
 * @param state   State of vuex User module.
 */
export function authorizedUser(state: AuthState): LoginModel | null {
    return state.loginModel;
}

export default {
    authorizedUser
} as GetterTree<AuthState, RootState>
